import { axios } from '@/services/axios';

/**
 * Signs up (creates) a new EightByEight service for a company.
 *
 * POST /Service/EightByEight/SignUp
 *
 * NOTE: Do NOT use this for connecting existing 8x8 services — sign-up only.
 *
 * @param {object} payload
 * @param {string} payload.companyID
 * @param {string} payload.addressID
 * @param {string} payload.phoneNumber
 * @param {string} payload.emailAddress
 * @returns {Promise<object>} the newly created EightByEight service definition
 */
const createEightByEightSignUp = async (payload) => {
    const res = await axios.post('/Service/EightByEight/SignUp', payload);
    return res.data;
};

export default createEightByEightSignUp;
